<template>
  <transition
    name="message-center--fade">
    <div class="massage-content">
      <header-general type="message" page-title="消息中心" @clickHandle="closeMessage"></header-general>
      <div class="message-body">
        <div class="scroll-box">
          <div class="notice_main_title notice_main_title_tab">
            <w-tabs :header-nav-style="{paddingLeft: '24px'}" v-model="messageTab">
              <template v-if="user.role === 1">
                <w-tab-pane label="角色待分配" name="5"></w-tab-pane>
                <!-- <w-tab-pane label="企业云产品管理" name="6"></w-tab-pane> -->
                <w-tab-pane label="系统消息" name="7"></w-tab-pane>
              </template>
              <template v-else>
                <w-tab-pane label="分享消息" name="3"></w-tab-pane>
                <template v-if="+user.role !== 5">
                  <w-tab-pane label="批注消息" name="1"></w-tab-pane>
                  <w-tab-pane label="项目消息" name="2"></w-tab-pane>
                  <w-tab-pane label="企业消息" name="4"></w-tab-pane>
                </template>
                <w-tab-pane label="系统消息" name="7"></w-tab-pane>
              </template>
            </w-tabs>
          </div>
          <div class="notice_main_body">
            <div class="notice_option">
              <div class="notice_main_child">
                <w-checkbox v-model="allCheck" @change="checkAll" :indeterminate="indeterminate" :disabled="!dataList.length">全选</w-checkbox>
                <w-button type="minor" @click="beDelete" :disabled="!dataList.length || !indeterminate && !allCheck">删除</w-button>
                <template v-if="messageTab !== '3'">
                  <w-button type="minor" @click="beRead" :disabled="!dataList.length || !indeterminate && !allCheck">标记为已读</w-button>
                  <w-button type="minor" @click="allRead" :disabled="!dataList.length">全部标记为已读</w-button>
                </template>
              </div>
              <div class="notice_main_child" v-if="messageTab === '3'">
                <w-select size="small" v-model="shareValue" placeholder="请选择...">
                  <w-option v-for="(item, index) in shareTypes" :key="index" :label="item.label"
                            :value="item.value"></w-option>
                </w-select>
              </div>
            </div>
            <div class="notice_main_box" :class="{pagination: total > 0}">
              <template v-if="+state === 1">
                <w-scrollbar wrap-style="overflow-x: hidden;" style="height: 100%;overflow-x: hidden;">
                  <ul>
                    <template v-if="messageTab === '3'">
                      <li v-for="(i, k) in dataList" :key="k" class="notice_main_item notice_main_share_item flex flex-row cursor-pointer">
                        <div class="notice_main_child notice_main_center">
                          <w-checkbox v-model="i.check" @change="checkItem" style="margin-right: 0;"></w-checkbox>
                          <label class="notice_item_img bg-blue" :class="{'read': i.readState === 2}">
                            <i class="r2-icon-social_share color-blue"></i>
                          </label>
                        </div>
                        <div class="notice_main_info notice_main_share_info notice_main_child cursor-auto flex-1 flex flex-row" v-if="i.receiverAccounts&&!i.shareRelationId">
                          <div :id="'notice_item_' + i.messageId" :class="['notice_main_content flex-1', i.readState==2 ? 'color_color_b2':'', 'notice_info-text']">
                            <div>
                              我分享给
                              <template v-if="(i.receiverAccounts.slice(0,-1).replace(/,/g, '、')+i.fileName).length <= 140">
                                {{i.receiverAccounts.slice(0,-1).replace(/,/g, '、')}}， {{i.fileName}}
                              </template>
                              <template v-else>
                                <w-more-text class="inline" :more-length="130 - i.fileName.length" suffixText="...等账号，">
                                  {{i.receiverAccounts.slice(0,-1).replace(/,/g, '、')}}
                                </w-more-text>
                                {{i.fileName}}
                                <!--{{i.receiverAccounts.slice(0,-1).replace(/,/g, '、').slice(0, 130-i.fileName.length)}} ...等账号， {{i.fileName}}-->
                              </template>
                            </div>
                          </div>
                          <div class="notice_main_msg-msg">
                            <span>{{new Date(i.shareTime).toLocaleString().replace(',', '').split(' ')[0]}}</span>
                          </div>
                        </div>
                        <div class="notice_main_info notice_main_share_info notice_main_child flex-1 flex flex-row" @click="goShare(i)" v-else-if="!i.shareLink">
                          <div :id="'notice_item_' + i.messageId" :class="['notice_main_content flex-1', i.readState==2 ? 'color_color_b2':'', 'notice_info-text']">
                            <div>
                              收到 {{i.authorAccount}} 分享的 {{i.fileName}} {{i.hasMarkup ? "工程有批注" : ""}}
                            </div>
                            <div class="notice_main_other_info">
                              {{i | remainTimeFilter}}
                            </div>
                          </div>
                          <div class="notice_main_msg-msg">
                            {{new Date(i.shareTime).toLocaleString().split(' ')[0]}}
                          </div>
                        </div>
                        <div class="notice_main_info notice_main_share_info notice_main_child cursor-auto flex-1 flex flex-row" v-else-if="!i.shareRelationId">
                          <div :id="'notice_item_' + i.shareId" :class="['notice_main_content flex-1', i.readState==2 ? 'color_color_b2':'', 'notice_info-text']">
                            <div>
                              <template v-if="(i.fileName + i.shareLink + 13).length <= 140">
                                我分享了 {{i.fileName}}，生成了分享链接：{{i.shareLink}}
                              </template>
                              <template v-else>
                                <w-more-text class="inline" :more-length="130" @click.stop="">
                                  我分享了 {{i.fileName}}，生成了分享链接：{{i.shareLink}}
                                </w-more-text>
                              </template>
                              <!--我分享了 {{i.fileName}}，生成了分享链接：{{i.shareLink}}-->
                            </div>
                            <div class="notice_main_other_info">
                              {{i | remainTimeFilter}}
                            </div>
                          </div>
                          <div class="notice_main_msg-msg">
                            {{new Date(i.shareTime).toLocaleString().split(' ')[0]}}
                          </div>
                        </div>
                        <div class="notice_main_info notice_main_share_info notice_main_child flex-1 flex flex-row" @click="goShare(i)" v-else>
                          <div :id="'notice_item_'+i.messageId" :class="['notice_main_content flex-1', i.readState==2 ? 'color_color_b2':'', 'notice_info-text']">
                            <div>
                              <template v-if="(i.shareLink + 8).length <= 140">
                                我收到分享链接：{{i.shareLink}}
                              </template>
                              <template v-else>
                                <w-more-text class="inline" :more-length="130" @click.stop="">
                                  我收到分享链接：{{i.shareLink}}
                                </w-more-text>
                              </template>
                              <!--我收到分享链接：{{i.shareLink}}-->
                            </div>
                            <div class="notice_main_other_info">
                              {{i | remainTimeFilter}}
                            </div>
                          </div>
                          <div class="notice_main_msg-msg">
                            {{new Date(i.shareTime).toLocaleString().split(' ')[0]}}
                          </div>
                        </div>
                      </li>
                    </template>
                    <template v-else>
                      <li v-for="(i, k) in dataList" :key="k" class="notice_main_item flex flex-row cursor-pointer">
                        <div class="notice_main_child notice_main_center">
                          <w-checkbox v-model="i.check" @change="checkItem" style="margin-right: 0;"></w-checkbox>
                          <label class="notice_item_img bg-green" :class="{'read': i.readState === 2}" v-if="i.messageType === 1">
                            <i class="r2-icon-cmc_chat color-green"></i>
                          </label>
                          <label class="notice_item_img bg-orange" :class="{'read': i.readState === 2}" v-if="i.messageType === 2">
                            <i class="r2-icon-av_featured_play_list color-orange"></i>
                          </label>
                          <label class="notice_item_img bg-purple" :class="{'read': i.readState === 2}" v-if="[4, 7].includes(i.messageType)">
                            <i class="r2-icon-cmc_business color-purple"></i>
                          </label>
                          <label class="notice_item_img bg-purple" :class="{'read': i.readState === 2}" v-if="i.messageType === 5">
                            <i class="r2-icon-social_group color-purple"></i>
                          </label>
                          <label class="notice_item_img bg-blue" :class="{'read': i.readState === 2}" v-if="i.messageType === 6">
                            <i class="r2-icon-device_widgets color-blue"></i>
                          </label>
                          <!--<input :checked="i.check" @click="checkItem(k)" class="notice__item-checkbox" type="checkbox">-->
                        </div>
                        <!--<div class="notice_main_child notice_main_img" @click="goDecration(i)">-->
                          <!--<img :src=" i | urlFilter" :class="i.type>3&&i.type<9?'item_auto_img':'item_img'" alt="图片"-->
                               <!--width="38"-->
                               <!--:height="i.type>3&&i.type<9?'':38"/>-->
                        <!--</div>-->
                        <div class="notice_main_info notice_main_child flex-1 flex flex-row" @click="goDecration(i)">
                          <div :id="'notice_item_' + i.messageId" :class="['notice_main_content flex-1', i.state==1 ? 'color_color_b2':'', 'notice_main_text']">
                            <div>
                              <template v-if="i.messageType === 1">
                                <template v-if="(i.author + (i.tip ? ('，' + i.tip) : '') + (i.content ? ('，' + i.content) : '')).length <= 140">
                                  {{i.author + (i.tip ? ('，' + i.tip) : '') + (i.content ? ('，' + i.content) : '')}}
                                </template>
                                <template v-else>
                                  <w-more-text class="inline" :more-length="130" @click.stop="">
                                    {{i.author + (i.tip ? ('，' + i.tip) : '') + (i.content ? ('，' + i.content) : '')}}
                                  </w-more-text>
                                </template>
                              </template>
                              <template v-else-if="i.messageType === 2">
                                <template v-if="i.type === 13">
                                  {{i.content || ''}}
                                </template>
                                <template v-else>
                                  <template v-if="![9, 10].includes(i.type)">
                                    <template v-if="((i.author || '') + (i.tip || '')).length <= 140">
                                      {{i.author || ''}}{{i.tip || ''}}
                                    </template>
                                    <template v-else>
                                      <w-more-text class="inline" :more-length="130" @click.stop="">
                                        {{i.author || ''}}{{i.tip || ''}}
                                      </w-more-text>
                                    </template>
                                  </template>
                                  <template v-else>
                                    {{i.type === 9 ? (i.content || '') : (i.tip || '')}}
                                  </template>
                                </template>
                              </template>
                              <template v-else-if="i.messageType === 7">
                                {{i.content}} <a v-if="i.extJson && i.extJson.extType === 0" @click.stop="handleAppeal(i)" href="javascript: void(0);" style="color: #2079FA;text-decoration: underline;">点此申诉</a>
                              </template>
                              <template v-else>
                                <template v-if="(i.content || '').length <= 140">
                                  {{i.content || ''}}
                                </template>
                                <template v-else>
                                  <w-more-text class="inline" :more-length="130" @click.stop="">
                                    {{i.content || ''}}
                                  </w-more-text>
                                </template>
                              </template>
                            </div>
                            <div class="notice_main_other_info relative" v-if="i.projectName">
                              <div class="absolute width-full ellipsis" :title="i.projectName" v-if="i.projectName.length > 40">{{i.projectName}}</div>
                              <div class="absolute width-full ellipsis" v-else>{{i.projectName}}</div>
                            </div>
                          </div>
                          <div class="notice_main_msg-msg">
                            {{new Date(i.createTime).toLocaleString()}}
                          </div>
                        </div>
                      </li>
                    </template>
                  </ul>
                </w-scrollbar>
              </template>
              <div class="flex width-full height-full justify-center align-center color-999" v-else>
                <template v-if="+state === 0">消息正在加载...</template>
                <template v-if="+state === 2">您当前还没有收到消息哦~</template>
                <template v-if="+state === 3">加载消息失败！</template>
              </div>
            </div>
            <div class="notice_pagination" v-if="total > 0">
              <w-pagination
                @current-change="handleCurrentChange"
                @size-change="handlePageSizeChange"
                background
                layout="prev, pager, next, sizes"
                :page-size="pageSize"
                :page-sizes="pageSizes"
                :total="total">
              </w-pagination>
            </div>
          </div>
          <div v-show="seclectConfirm" class="notice_alert">
            <i class="iconfont w-icon-qiangtixing"></i>
            未选中任何通知
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import HeaderGeneral from '_c/common/Header/HeaderGeneral.vue'
import MessageService from '@/assets/service/message'
import deleteUser from '@/assets/images/delete-user.png'
import addUser from '@/assets/images/add-user.png'
import file from '@/assets/images/file.png'
import files from '@/assets/images/files.png'
import folder from '@/assets/images/folder.png'
import {capitalize} from '@/assets/utils'
import queryString from 'querystring'
import {mapState} from 'vuex'

export default {
  name: 'MainMessage',
  data () {
    return {
      state: 0, // 0 loading; 1 success; 2 nodata; 3 error;
      dataList: [],
      pageNum: 1,
      pageSize: 50,
      pageSizes: [50, 100],
      total: 0,
      allCheck: false,
      indeterminate: false,
      deleteConfirm: false,
      seclectConfirm: false,
      messageTab: '3',
      shareValue: 0,
      shareTypes: [
        {value: 0, label: '全部分享'},
        {value: 2, label: '我分享的消息'},
        {value: 1, label: '分享给我的消息'}
      ]
    }
  },
  components: {
    HeaderGeneral
  },
  computed: {
    ...mapState({
      userType: state => state.user.user.userType
    })
  },
  mounted () {
    const messageTab = this.messageTab
    this.messageTab = Number(window.messageTab) ? window.messageTab : this.user.role === 1 ? '5' : '3'
    if (this.messageTab === messageTab) {
      this.log(this.messageTab)
    }
    this.shareValue = 0
    if (this.messageTab === '3') {
      this.sentLog(100110017)
    }
    this.resetData()
    this.queryMessageList()
  },
  watch: {
    messageTab () {
      this.log(this.messageTab)
      this.pageNum = 1
      this.total = 0
      this.indeterminate = false
      this.allCheck = false
      this.$nextTick(() => {
        this.state = 0
        this.dataList = []
        this.queryMessageList()
      })
    },
    shareValue () {
      this.pageNum = 1
      this.total = 0
      this.indeterminate = false
      this.allCheck = false
      this.$nextTick(() => {
        this.state = 0
        this.dataList = []
        this.queryMessageList()
      })
      switch (this.shareValue) {
        case 0:
          this.sentLog(100110017)
          break
        case 1:
          this.sentLog(100110015)
          break
        case 2:
          this.sentLog(100110016)
          break
        default:
          break
      }

    }
  },
  filters: {
    urlFilter (data) {
      let val = ''
      if (+data.type === 4) {
        val = addUser
      } else if (+data.type === 5) {
        val = deleteUser
      } else if (+data.type === 6) {
        val = file
      } else if (+data.type === 7) {
        val = files
      } else if (+data.type === 8) {
        val = folder
      } else {
        val = data.signedUrl
      }
      return val
    },
    remainTimeFilter (i) {
      let time = i.remainTime
      if (!i.shareLink && +i.state !== 2) {
        return ''
      }
      if (+i.state === 2) {
        return '已失效'
      }

      if (
        typeof time === 'object'
      ) {
        return '永久有效'
      } else if (
        typeof time !== 'object' && time <= 0
      ) {
        return '已失效'
      } else {
        let days = Math.floor(time / 86400000)
        let hours = Math.ceil((time % 86400000) / 3600000)
        let timeResult = days ? `${days}天${hours}小时` : `${hours}小时`
        return `剩余有效期：${timeResult}`
      }
    }
  },
  methods: {
    // 1. 触发埋点
    log (type) {
      let fnCode = 0
      switch (type + '') {
        case '1':
          fnCode = 100110012
          break
        case '2':
          fnCode = 100110013
          break
        case '3':
          fnCode = 100110011
          break
        case '4':
          fnCode = 100110014
          break
        default:

      }
      if (fnCode) {
        this.sentLog(fnCode)
      }
    },
    // 重置数据
    resetData () {
      this.pageNum = 1
      this.state = 0
      this.total = 0
      this.allCheck = false
      this.dataList = []
    },
    // 打开
    openHandle (i) {
      this.dataList[i].open = !this.dataList[i].open
      this.$forceUpdate()
    },
    // 标记分享消息已读
    alreadReadShareMessage (i) {
      i.readState = 2
      MessageService.getShareMessagesRead({shareRelationId: i.shareRelationId}).then((res) => {

      })
    },
    // 跳转到分享页面
    goShare (i) {
      // 标记该信息已读
      this.alreadReadShareMessage(i)
      // 失效消息不可点击
      if ((typeof i.remainTime !== 'object' && +i.remainTime <= 0) || +i.state === 2) {
        return
      }
      // 打开外链
      let suffix = i.fileName.split('.').reverse()[0]
      let queryParams = queryString.stringify({
        shareToken: i.shareToken ? i.shareToken : 'null',
        fileId: i.fileId ? i.fileId : 'null',
        fileType: i.fileType ? i.fileType : 'null',
        jsonToken: i.jsonToken ? i.jsonToken : 'null',
        fileName: i.fileName ? i.fileName : 'null',
        shareId: i.shareId
      })
      let newUrl = `/#/share/${capitalize(suffix, true, true)}?${queryParams}`
      window.open(newUrl, '_blank')
    },
    // 删除
    beDelete () {
      let arr = []
      this.dataList.forEach((item) => {
        if (item.check) {
          arr.push(item.messageId)
        }
      })
      if (!arr.length) {
        this.seclectConfirm = true
        setTimeout(() => {
          this.seclectConfirm = false
        }, 3000)
        return
      }
      this.$confirm({
        message: '确定删除',
        tips: '确定要把通知删除？',
        tipsRed: '删除将无法找回！',
        submit: () => {
          if (this.messageTab === '3') {
            this.doShareDelete()
          } else {
            this.deleteSure()
          }

        },
        submitText: '确定'
      })
    },
    // 删除分享消息
    doShareDelete () {
      let _self = this
      let queryParams = {}
      let arr1 = []
      let arr2 = []
      let arrlen = 0
      this.dataList.map((item) => {
        if (item.check) {
          if (item.shareRelationId) {
            arr1.push(item.shareRelationId)
          } else {
            arr2.push(item.shareId)
          }
          arrlen++
        }
      })
      queryParams.shareRelationIdList = arr1.join(',')
      queryParams.shareIdList = arr2.join(',')
      if (this.dataList.length === arrlen && +this.pageNum !== 1) {
        this.pageNum = this.pageNum - 1
      }
      MessageService.deleteShareMessages(queryParams).then((res) => {
        if (+res.code === 200) {
          _self.queryMessageList()
        } else {
          this.$message.error('删除失败！')
        }
      }).catch((err) => {
        this.$message.error('删除失败！')
        console.log(err)
      })
    },
    // 确定删除
    deleteSure () {
      let arr = []
      this.dataList.map((item) => {
        if (item.check) {
          arr.push(item.messageId)
        }
      })
      this.deleteMessage(arr.join(','))
    },
    // 选择
    checkItem (i) {
      // this.dataList[i].check = !this.dataList[i].check
      let allcheck = true
      if (!this.dataList.length) {
        allcheck = false
      }
      this.dataList.map((item) => {
        if (!item.check) {
          allcheck = false
        }
      })
      let checked = this.dataList.filter(item => item.check)
      this.indeterminate = (checked.length > 0 && checked.length !== this.dataList.length)
      // console.log(allcheck)
      this.allCheck = allcheck
    },
    // 全选
    checkAll () {
      // this.allCheck = !this.allCheck
      // this.$nextTick(()=>{
      this.indeterminate = false
      if (this.allCheck) {
        this.dataList.map((item) => {
          item.check = true
        })
      } else {
        // console.log(333)
        this.dataList.map((item) => {
          item.check = false
        })
      }
      this.$forceUpdate()
      // })
    },
    // 页码更改
    handleCurrentChange (val) {
      this.pageNum = val
      this.indeterminate = false
      this.queryMessageList()
    },
    // 更改页面大小
    handlePageSizeChange (index) {
      this.pageSize = index
      this.pageNum = 1
      this.indeterminate = false
      this.queryMessageList()
    },
    // 关闭弹框
    closeMessage () {
      this.$emit('closeMessage')
    },
    // 展示消息弹框
    showAllNotice () {
      this.$emit('showAllNotice')
    },
    // 阻止冒泡
    messageHandle () {
    },
    // 批量已读
    beRead () {
      let arr = []
      this.dataList.forEach((item) => {
        if (item.check) {
          arr.push(item.messageId.toString())
        }
      })
      arr.length && this.alreadReadMessage(arr)
    },
    // 全部已读
    allRead () {
      this.dataList.length && this.alreadReadMessage([])
    },
    // 请求消息列表
    queryMessageList () {
      // this.pageNum = 1;
      // this.total = 0;
      this.indeterminate = false
      this.allCheck = false
      let _self = this
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      let messageTab = _self.messageTab
      _self.dataList = []
      _self.allCheck = false
      _self.state = 0
      if (messageTab === '3') {
        let serveName = ''
        if (this.shareValue === 0) {
          serveName = 'getAllShareMessages'
        } else if (this.shareValue === 1) {
          serveName = 'getReceivedShareMessages'
        } else {
          serveName = 'getSendedHasShareMessages'
        }
        MessageService[serveName](params).then((res) => {
          if (messageTab !== _self.messageTab) {
            return
          }
          if (+res.code === 200) {
            if (res.data.totalCount) {
              _self.total = res.data.totalCount
              _self.state = 1
              // res.data.items.forEach(item => (item.check = false))
              let items = res.data.items || []
              items.forEach((item, index) => {
                item.check = false
                if (item.extJson) {
                  try {
                    item.extJson = JSON.parse(item.extJson)
                  } catch (e) {
                    item.extJson = {}
                  }
                }
              })
              _self.dataList = items
              // _self.dataList = res.data.items
            } else {
              _self.state = 2
            }
          } else {
            _self.state = 3
          }
        }).catch((err) => {
          _self.state = 3
          console.log(err)
        })
      } else {
        params.type = messageTab
        MessageService.queryMessageList(params).then((res) => {
          if (messageTab !== _self.messageTab) {
            return
          }
          if (+res.code === 200) {
            if (res.data.totalCount) {
              _self.total = res.data.totalCount
              _self.state = 1
              // res.data.items.forEach(item => (item.check = false))
              let items = res.data.items || []
              items.forEach((item, index) => {
                item.check = false
                if (item.extJson) {
                  try {
                    item.extJson = JSON.parse(item.extJson)
                  } catch (e) {
                    item.extJson = {}
                  }
                }
              })
              _self.dataList = items
              // _self.dataList = res.data.items
            } else {
              _self.state = 2
            }
          } else {
            _self.state = 3
          }
        }).catch((err) => {
          _self.state = 3
          console.log(err)
        })
      }
    },
    // 删除消息
    deleteMessage (id) {
      let idlen = id.split(',')
      if (this.dataList.length === idlen && +this.pageNum !== 1) {
        this.pageNum = this.pageNum - 1
      }
      let _self = this
      // let query = {state: 1};
      MessageService.deleteMessageState(id).then((res) => {
        if (+res.code === 200) {
          _self.queryMessageList()
        }
      }).catch((err) => {
        console.log('修改状态失败！')
        console.log(err)
      })
    },
    // 标记消息已读
    alreadReadMessage (id) {
      let type = this.messageTab
      let query = {}
      if (type) {
        query.type = type
      } else {
        query.type = ''
      }
      MessageService.putMessageState(id, query).then((res) => {
        if (+res.code === 200) {
          this.queryMessageList()
        }
      }).catch((err) => {
        console.log('修改状态失败！')
        console.log(err)
      })
    },
    // 点击消息、标记已读并跳转
    goDecration (i) {
      // 标记该信息已读
      this.alreadReadMessage([i.messageId.toString()])
      if (i.messageType === 5) {
        // 点击角色待分配
        this.$emit('closeMessage', '/manage/members')
      } else if (i.messageType === 6) {
        // 点击 企业数据库 管理
        this.$emit('closeMessage', '/manage/applications')
      } else if (+i.type === 4 || +i.type === 5 || +i.type === 6 || +i.type === 7 || +i.type === 8) {
        // 打开装饰外链
        window.open(window.location.origin + '/#/project/joined/list', 'zjy-deco')
      } else if (i.url) {
        let newUrl = i.url.replace(/:\/\/.*?deco-browsing/, `://${window.location.host}/deco-browsing`)
        window.open(newUrl, 'zjy-deco')
        if (window.name === 'zjy-deco') {
          this.closeMessage()
        }
      }
    },
    // 点击申诉
    handleAppeal (i) {
      this.$emit('closeMessage', 'ugc', i.extJson)
    }
  }
}
</script>

<style lang="less">
  .message-center--fade-enter-active {
    animation: dialog-fade-in .3s;
  }
  .message-center--fade-leave-active {
    animation: dialog-fade-out .3s;
  }
  @keyframes dialog-fade-in {
    0% {
      transform: translate3d(0, -20px, 0);
      opacity: 0;
    }
    100% {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  }
  @keyframes dialog-fade-out {
    0% {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
    100% {
      transform: translate3d(0, -20px, 0);
      opacity: 0;
    }
  }

  .massage-content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #f2f3f6;
    z-index: 2001;

    .message-body {
      height: calc(100% - 56px);
      box-sizing: border-box;
      overflow: hidden;
      padding: 24px 0;
      .w__tabs__item {
        height: 52px !important;
        line-height: 52px !important;
      }

      .scroll-box {
        width: 860px;
        height: 100%;
        margin: 0 auto;
        background: #ffffff;
        box-sizing: border-box;

        .notice_main_title {
          height: 66px;
        }

        .notice_main_body {
          overflow: hidden;
          /*padding: 0 24px 12px 24px;*/
          height: calc(100% - 66px);
          box-sizing: border-box;

          .notice_option {
            height: 32px;
            padding: 0 24px 0 27px;

            .notice_main_child {
              display: inline-block;
              word-break: break-all;

              & + .notice_main_child {
                float: right;
              }
            }
          }

          .notice_main_box {
            height: calc(100% - 32px);
            padding: 20px 0;
            box-sizing: border-box;
            &.pagination {
              height: calc(100% - 106px);
            }
            ul {
              padding: 0 24px 0 27px;
              margin: 0;
              box-sizing: border-box;
              .notice_main_item {
                padding: 13px 0;
                border-bottom: 1px solid rgba(33,37,48,0.1);;
                &:last-child {
                  border-bottom: 0;
                }
                .notice_main_child {
                  /*width: calc(100% - 20px);*/
                  /*display: inline-block;*/
                  margin-left: 16px;
                  &:first-child {
                    margin-left: 0;
                    width: 60px;
                    vertical-align: top;
                  }
                  .notice_item_img {
                    /*margin-top: 3px;*/
                    margin-left: 16px;
                    width: 24px;
                    height: 24px;
                    text-align: center;
                    line-height: 24px;
                    border-radius: 50%;
                    display: inline-block;
                    &.bg-blue {
                      background-color: rgba(32,121,250,0.1);;
                    }
                    &.bg-green {
                      background-color: rgba(0,196,97,0.1);;
                    }
                    &.bg-orange {
                      background-color: rgba(248,149,2,0.1);;
                    }
                    &.bg-purple {
                      background-color: rgba(158,70,204,0.1);
                    }
                    &.read {
                      opacity: 0.6;
                    }
                    i {
                      display: inline-block;
                      font-size: 16px;
                    }
                    .item_auto_img {
                      height: 38px !important;
                      width: auto !important;
                    }
                    .item_img {
                      background: #ddd;
                    }
                  }
                  .notice_main_content {
                    word-break: break-all;
                    font-size: 14px;
                    line-height: 22px;
                    .notice_main_other_info {
                      color:rgba(33,37,48,0.55);
                      height: 24px;
                      font-size: 12px;
                      line-height: 22px;
                    }
                  }
                  .notice_main_msg-msg {
                    font-size: 12px;
                    line-height: 22px;
                    padding-left: 37px;
                    color:rgba(33,37,48,0.55);
                  }
                }
              }
            }
          }
          .notice_pagination {
            text-align: right;
            height: 84px;
            padding: 24px 24px 24px 27px;
            box-sizing: border-box;
          }
        }
      }
    }
  }

  .notice_alert {
    z-index: 10000;
    width: 240px;
    padding: 8px 16px;
    border-radius: 5px;
    box-sizing: border-box;
    border: 1px solid #ffe7b8;
    position: fixed;
    background-color: #fff7e6;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    transition: opacity .5s, transform .3s, left .3s, right .3s, top .4s, bottom .3s;
    font-size: 12px;
    color: #333;
    top: 40px;
    left: 50%;
    margin-left: -120px;
  }

  .iconfont {
    /*color: #e6a23c;*/
  }

  .w__dialog--wall {
    overflow: auto;
  }

  .main {
    /*.w__dialog--header {*/
      /*padding: 0 10px;*/
      /*color: #787878;*/
      /*font-size: 16px;*/
      /*height: 44px;*/
      /*line-height: 44px;*/
      /*border-bottom: 1px solid #ddd;*/
    /*}*/

    /*.w__dialog--header .dialog-close .icon-close {*/
      /*margin-right: 10px;*/
      /*line-height: 44px;*/
      /*float: right;*/
      /*width: 30px;*/
      /*height: 45px;*/
      /*text-align: center;*/
      /*cursor: pointer;*/
      /*color: #B5B5B5;*/
    /*}*/

    .notice_main {
      width: 920px;
      height: 650px;
      background: #fff;
      border-radius: 5px;

      .w-button {
        &:hover {
          background-color: #fbfbfb;
          text-decoration: none;
          background: -webkit-gradient(linear, 50% 0, 50% 100%, color-stop(0%, #fff), color-stop(100%, #f3f3f3));
          background: linear-gradient(top, #fff, #f3f3f3)
        }
      }

      .w__dialog--body {
        padding: 0;
        font-size: 12px;
      }

      .w__pagination.is-background {
        text-align: center;
        padding: 20px;
        padding-top: 15px;
      }

      .notice_main_tittle {
        width: 100%;
        /*position: relative;*/
        /*padding: 0 10px;*/
        /*color: #787878;*/
        /*font-size: 16px;*/
        /*height: 44px;*/
        /*line-height: 44px;*/
      }

      .notice_main_tittle_tab {
        /*border-bottom: 1px solid #ddd;*/
      }

      .notice_main_close {
        float: right;
        width: 30px;
        height: 45px;
        text-align: center;
        cursor: pointer;
        color: #B5B5B5;
      }


      .notice_option {
        margin: 15px 0;
        overflow: hidden;

        &.flex-middle {
          display: flex;
          align-items: center;
          padding-left: 20px;

          .margin-right-30 {
            margin-right: 30px;
            margin-left: 3px;
          }
        }
      }


      .notice__items-checkbox {
        margin-right: 10px;
      }

      .notice_main_center {
        line-height: 40px;
      }


      .notice_main_share_item {

      }

      .notice_main_img {
        width: 38px;
        height: 38px;

        img {
          display: inline-block;
        }

        .item_auto_img {
          height: 38px !important;
          width: auto !important;
        }

        .item_img {
          background: #ddd;
        }
      }

      .notice_main_info {
        color: #333;
        width: calc(100% - 150px);

        &.notice_main_share_info {
          width: calc(100% - 90px);
          position: relative;

          .open-icon {
            position: absolute;
            top: -6px;
            right: -51px;
            font-size: 13px;
            color: #999999;
            cursor: pointer;
          }

          .icon-rotate-180 {
            transform: rotate(180deg);
            transition: all 0.5s;
          }

          .icon-rotate-0 {
            transform: rotate(0deg);
            transition: all 0.5s;
          }
        }
      }

      .notice_main_text {
        font-size: 14px;
        color: #303133;
        position: relative;
        line-height: 20px;
        max-height: 20px;
        height: 20px;
        margin-bottom: 5px;
        overflow: hidden;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }

      .notice_main_msg {
        color: #909399;
      }

      .notice_main_msg span {
        float: left;
      }

      .current {
        background-color: #1C6CCD;
        border-color: #1C6CCD;
        color: #fff;
      }

      .notice_deletepop {
        border: 1px solid;
        border-image: linear-gradient(0deg, rgb(219, 212, 212), rgb(249, 236, 236), rgb(230, 224, 224), rgb(234, 228, 228)) 1 1;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      }
    }
  }

</style>
